import { ShieldCheck, ClipboardList, HeartHandshake } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { GreekWatermark } from "@/components/GreekWatermark";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Professional Coaching",
    desc: "Every session is led by experienced coaches.",
  },
  {
    icon: ClipboardList,
    title: "Structured Programming",
    desc: "Every workout has a purpose.",
  },
  {
    icon: HeartHandshake,
    title: "Community",
    desc: "Train alongside people who genuinely want to see you succeed.",
  },
];

export function ElysiumStandard() {
  return (
    <section id="standard" className="scroll-mt-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 relative" data-testid="elysium-standard-section">
      <GreekWatermark letter="Δ" className="top-0 left-0 sm:left-10" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative">
        <Reveal>
          <p className="eyebrow">The Elysium Standard</p>
          <h2 className="font-anton uppercase tracking-tight text-cream text-4xl sm:text-6xl leading-[0.95] mt-3">
            More than a workout.
          </h2>
          <p className="text-smoke mt-6 leading-relaxed max-w-lg text-base sm:text-lg">
            We combine attentive coaching, intelligent programming and a genuinely supportive training environment.
          </p>
        </Reveal>
        <Reveal delay={0.1} className="relative aspect-[4/5] sm:aspect-[4/3] lg:aspect-[4/5] max-h-[640px] w-full overflow-hidden border border-gold/25">
          <video src="/videos/elysium-highlights.mp4" poster="/videos/elysium-highlights-poster.jpg" autoPlay muted loop playsInline preload="metadata"
            className="w-full h-full object-cover" data-testid="standard-video" aria-label="Elysium training highlights" />
          <div className="absolute inset-0 bg-gradient-to-t from-void via-void/10 to-transparent" />
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-16">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <div className="bg-surface border border-line hover:border-gold/50 transition-colors p-7 h-full" data-testid={`elysium-standard-pillar-${i}`}>
              <p.icon className="h-7 w-7 text-gold mb-4" />
              <h3 className="font-anton uppercase text-cream text-lg mb-1.5">{p.title}</h3>
              <p className="text-smoke text-sm leading-relaxed">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
